import { createContext, useContext, useEffect, useState, useCallback } from "react";
import api from "@/lib/api";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  // user: null = loading, false = not authenticated, object = authenticated
  const [user, setUser] = useState(null);

  const refresh = useCallback(async () => {
    try {
      const { data } = await api.get("/auth/me");
      setUser(data);
      return data;
    } catch {
      setUser(false);
      return null;
    }
  }, []);

  useEffect(() => {
    refresh();
  }, [refresh]);

  const logout = useCallback(async () => {
    try {
      await api.post("/auth/logout");
    } catch {
      /* ignore network errors during logout */
    }
    localStorage.removeItem("sensorize_token");
    setUser(false);
  }, []);

  const setSession = useCallback((userData, token) => {
    if (token) localStorage.setItem("sensorize_token", token);
    setUser(userData);
  }, []);

  return (
    <AuthContext.Provider value={{ user, setUser, refresh, logout, setSession }}>
      {children}
    </AuthContext.Provider>
  );
}

export function useAuth() {
  return useContext(AuthContext);
}
